import React from 'react';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-white border-t border-gray-100" data-id="element-293">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-294">
        <div className="flex flex-col md:flex-row items-center gap-8 border-2 border-[#1e3a5f]/10 rounded-2xl p-8 bg-[#f8fafc]" data-id="element-295">
          <div className="flex-shrink-0" data-id="element-296">
            <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-md border-4 border-[#d4a574]" data-id="element-297">
              <Shield className="w-12 h-12 text-[#1e3a5f]" data-id="element-298" />
            </div>
          </div>
          <div className="text-center md:text-left" data-id="element-299">
            <h3 className="text-2xl font-serif font-bold text-[#1e3a5f] mb-2" data-id="element-300">
              Garantía de Satisfacción de 30 Días
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-301">
              Estoy tan segura de que este pack transformará tus finanzas que
              asumo todo el riesgo. Si aplicas el método durante 30 días y no
              sientes que has tomado el control de tu dinero, te devuelvo el
              100% de tu inversión. Sin preguntas incómodas.
            </p>
            <p className="text-sm font-bold text-[#1e3a5f]" data-id="element-302">
              Tu tranquilidad es mi prioridad.
            </p>
          </div>
        </div>
      </div>
    </section>;
}